import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { all_routes } from "../../Router/all_routes";
import { ErrorToaster, SuccessToaster } from "../components/toaster/Toaster";
import { Form } from "./components/form";
import UserServices from "../../services/User";

const UpdateUser = () => {

  const { id } = useParams();
  const routes = all_routes;
  const navigate = useNavigate();

  // *For Loading
  const [loading, setLoading] = useState(false);

  // *For Submit Form
  const updateUser = async (payload) => {
    setLoading(true)
    try {
      const { message } = await UserServices.updateUser(id, payload)
      SuccessToaster(message)
      navigate(-1)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="page-wrapper">
      <div className="content p-2">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Edit User</h4>
              <h6>Edit user</h6>
            </div>
          </div>
        </div>
        <Form onSubmit={updateUser} loading={loading} />
      </div>
    </div>
  );
};

export default UpdateUser;
